import { defaultSearch } from '../contexts/SearchContext'
import { formatNumber } from './Helper'

const capitalize = value => value.charAt(0).toUpperCase() + value.slice(1)

const listLabel = (prefix, selected) => {
  const labels = (selected || []).map(item => item.label)
  if (labels.length <= 2) return `${prefix}: ${labels.join(', ')}`
  return `${prefix}: ${labels.slice(0, 2).join(', ')} +${labels.length - 2}`
}

export const activeFilterChips = search => {
  const defaults = defaultSearch()
  const chips = []

  if (+search.min_reach !== defaults.min_reach || +search.max_reach !== defaults.max_reach) {
    chips.push({
      key: 'reach',
      label: `Reach: ${formatNumber(+search.min_reach || 0)} – ${formatNumber(+search.max_reach || 0)}`,
      clear: () => { search.min_reach = defaults.min_reach; search.max_reach = defaults.max_reach }
    })
  }

  if (+search.min_engagement_rate > 0) {
    chips.push({ key: 'engagement', label: `Eng. rate ≥ ${search.min_engagement_rate}%`, clear: () => { search.min_engagement_rate = 0 } })
  }

  if (search.gender.size) {
    chips.push({ key: 'gender', label: `Gender: ${Array.from(search.gender).map(capitalize).join(', ')}`, clear: () => search.gender.clear() })
  }

  if (search.age_group.length) {
    chips.push({ key: 'age_group', label: listLabel('Age', search.selectedAgeGroups), clear: () => { search.age_group = []; search.selectedAgeGroups = [] } })
  }

  if (search.country.length) {
    chips.push({ key: 'country', label: listLabel('Country', search.selectedCountries), clear: () => { search.country = []; search.selectedCountries = [] } })
  }

  if (search.city.length) {
    chips.push({ key: 'city', label: listLabel('City', search.selectedCities), clear: () => { search.city = []; search.selectedCities = [] } })
  }

  if (search.audience_gender) {
    chips.push({ key: 'audience_gender', label: `Audience: mostly ${search.audience_gender === 'equal' ? 'balanced' : search.audience_gender}`, clear: () => { search.audience_gender = '' } })
  }

  if (search.audience_age_groups.length) {
    chips.push({
      key: 'audience_age_groups',
      label: listLabel('Audience age', search.selectedAudienceAgeGroups),
      clear: () => { search.audience_age_groups = []; search.selectedAudienceAgeGroups = []; search.order = 'reach' }
    })
  }

  if (search.audience_countries.length) {
    chips.push({
      key: 'audience_countries',
      label: `${listLabel('Audience country', search.selectedAudienceCountries)} (≥ ${search.min_audience_country_percentage}%)`,
      clear: () => { search.audience_countries = []; search.selectedAudienceCountries = []; search.order = 'reach' }
    })
  }

  if (search.audience_cities.length) {
    chips.push({
      key: 'audience_cities',
      label: listLabel('Audience city', search.selectedAudienceCities),
      clear: () => { search.audience_cities = []; search.selectedAudienceCities = []; search.order = 'reach' }
    })
  }

  return chips
}

export const hasAnyRefinement = search => (
  activeFilterChips(search).length > 0 ||
  !!search.username ||
  search.provider !== 'All' ||
  search.tags.length > 0 ||
  !!search.reachbird_approved
)
